import React from 'react';
import RCTooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import './style.css';


const ToolTip = ({ children, style, ...rest }) => (
  <RCTooltip overlayInnerStyle={style} {...rest}>
    {children}
  </RCTooltip>
);

export default ToolTip;
